import React from 'react'
import { Box, Typography } from '@mui/material'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import '../../../src/assets/css/admission.css'
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
const TimeLine = ({journeys}) => {


    const colorStyles = [
        { color: '#038FF5', bg: '#0D99FF1A', },
        {color:'#FDC727', bg: '#FDC7271A' },
        { bg: '#FDC7271A', color: '#FDC727' },
        { bg: '#FDF0F0', color: '#FDC727' },
        { bg: '#EDF4FF', color: '#0B63CE' },
    ];

    const navigationType = (action) => {
        const type = action?.toLowerCase()
        let attribute = {
            background: '#14AE5C',
            icon: <LanguageOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
        }

        if (type?.includes('click')) {
            attribute.background = '#AD46FF'
            attribute.icon = <SendOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
        } else if (type?.includes('select')) {
            attribute.background = '#FB2C36'
            attribute.icon =  <LibraryBooksOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
        }

        return attribute

    }
    return (
        <>
            <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '25px', borderRadius: '16px', marginBottom: '25px' , height: '585px' , overflowY: 'scroll'}}>
                <Box>
                    <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: {xl: '24px !important' , lg: '17px !important'}, marginBottom: '35px', fontWeight: '500' }}>User Journey Timeline</Typography>
                </Box>
                <Box>
                    <Timeline className='timelineuserpage' sx={{
                        display: 'flex', alignItems: 'start', justifyContent: 'start', padding: '0'
                    }}>
                        {journeys?.map((ele,index)=>{
                             const style = colorStyles[index % colorStyles.length];
                             const attribute = navigationType(ele?.action)
                            return <TimelineItem key={ele?._id} sx={{ padding: '0', width: '100%' }}>
                            <TimelineSeparator >
                                <Box sx={{ width: '44px', height: '44px', borderRadius: '14px', background: attribute?.background, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                   {attribute?.icon}
                                </Box>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '15px', borderRadius: '12px', marginBottom: '30px' }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent:'space-between', alignItems: 'center' }}>
                                        <Typography variant='h4' sx={{ color: '#1E1E1E', marginBottom: '6px', fontWeight: '400', fontSize: {xl: '16px !important' , lg: '12px !important'} }}>{ele?.action || "-"}</Typography>
                                        {ele?.tag &&<Typography variant='h4' sx={{ color: style?.color || '#038FF5', background: style?.bg || '#0D99FF1A', marginBottom: '6px', padding: '2px 10px', borderRadius: '9px',textTransform: 'capitalize',textAlign: 'center', height: '26px', fontWeight: '400', fontSize: {xl: '16px !Important' , lg: '13px !important'}, lineHeight: '21px' }}>{ele?.tag}</Typography>}

                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'} }}>{ele?.date || "-"} </Typography>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'} }}>{ele?.time || "-"}</Typography>
                                    </Box>
                                    <Typography sx={{ color: '#1E1E1E', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '13px' , lg: '11px'}}}>{ele?.description || "-"}</Typography>
                                </Box>
                            </TimelineContent>
                        </TimelineItem>})}


                        {/* <TimelineItem sx={{ padding: '0', width: '100%' }}>
                            <TimelineSeparator>
                                <Box sx={{ width: '44px', height: '44px', borderRadius: '14px', background: '#AD46FF', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <SendOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
                                </Box>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '15px', borderRadius: '12px', marginBottom: '30px' }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant='h4' sx={{ color: '#1E1E1E', marginBottom: '6px', fontWeight: '400', fontSize: {xl: '16px !important' , lg: '12px !important'} }}>Clicked on 'Explore Courses'</Typography>
                                        <Typography variant='h4' sx={{ color: '#FDC727', background: '#FDC7271A', marginBottom: '6px', padding: '2px 10px', borderRadius: '9px', width: {xl: '76px' , lg: '55px'}, textAlign: 'center', height: '26px', fontWeight: '400', fontSize: {xl: '16px !Important' , lg: '13px !important'}, lineHeight: '21px' }}>Course</Typography>

                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'}  }}>18 June 2025 </Typography>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'}  }}>17:23:00</Typography>
                                    </Box>
                                    <Typography sx={{ color: '#1E1E1E', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '13px' , lg: '11px'} }}>Navigated to courses listing page</Typography>
                                </Box>
                            </TimelineContent>
                        </TimelineItem>

                        <TimelineItem sx={{ padding: '0', width: '100%' }}>
                            <TimelineSeparator>
                                <Box sx={{ width: '44px', height: '44px', borderRadius: '14px', background: '#FB2C36', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <LibraryBooksOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
                                </Box>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '15px', borderRadius: '12px', marginBottom: '30px' }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant='h4' sx={{ color: '#1E1E1E', marginBottom: '6px', fontWeight: '400', fontSize: {xl: '16px !important' , lg: '12px !important'}}}>Selected Course: MBA FinTech</Typography>

                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize:{xl: '15px' , lg: '12px'} }}>18 June 2025 </Typography>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'}  }}>17:23:00</Typography>
                                    </Box>
                                    <Typography sx={{ color: '#1E1E1E', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '13px' , lg: '11px'} }}>Viewed course details</Typography>
                                </Box>
                            </TimelineContent>
                        </TimelineItem>
                       <TimelineItem sx={{ padding: '0', width: '100%' }}>
                            <TimelineSeparator>
                                <Box sx={{ width: '44px', height: '44px', borderRadius: '14px', background: '#AD46FF', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <SendOutlinedIcon sx={{ color: '#fff', fontSize: '25px' }} />
                                </Box>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '15px', borderRadius: '12px', marginBottom: '30px' }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant='h4' sx={{ color: '#1E1E1E', marginBottom: '6px', fontWeight: '400', fontSize: {xl: '16px !important' , lg: '12px !important'} }}>Clicked on 'Explore Courses'</Typography>
                                        <Typography variant='h4' sx={{ color: '#FDC727', background: '#FDC7271A', marginBottom: '6px', padding: '2px 10px', borderRadius: '9px', width: {xl: '76px' , lg: '55px'}, textAlign: 'center', height: '26px', fontWeight: '400', fontSize: {xl: '16px !Important' , lg: '13px !important'}, lineHeight: '21px' }}>Course</Typography>

                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'}  }}>18 June 2025 </Typography>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '15px' , lg: '12px'}  }}>17:23:00</Typography>
                                    </Box>
                                    <Typography sx={{ color: '#1E1E1E', fontWeight: '400', marginBottom: '6px', fontSize: {xl: '13px' , lg: '11px'} }}>Navigated to courses listing page</Typography>
                                </Box>
                            </TimelineContent>
                        </TimelineItem>   */}
                    </Timeline>
                </Box>
            </Box>
        </>
    )
}

export default TimeLine